module.exports = __webpack_public_path__ + "static/media/logo.3bb9c137.png";